import React, { useState, useEffect } from "react";
import { Line } from "@ant-design/plots";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";

const TopPlanProgressGraph = (props) => {
  const [canStart, setCanStart] = useState(false);
  const perfCycleState = useSelector((state) => state.perfCycleState.value);
  let curLocation = useLocation();

  const [duration, setDuration] = useState(0);

  useEffect(() => {
    let path = curLocation.pathname;
    let id = path.split("/top-plans/");
    getProgressData(id[1]);
    getInterval();
  }, [curLocation]);

  async function getProgressData(id) {
    setCanStart(true);
  }

  function getInterval() {
    const duration =
      (moment(perfCycleState?.endingOn) - moment(perfCycleState?.startingOn)) /
      (1000 * 60 * 60 * 24);

    setDuration(duration);
  }

  function generateGraphData() {
    const data = [];
    
    // Add starting point for current progress
    data.push({
      Date: moment(perfCycleState?.startingOn).format("DD.MM.YYYY"),
      scales: 0,
      category: "Current",
    });

    // Add current progress point
    data.push({
      Date: getCurrentDate().format("DD.MM.YYYY"),
      scales: props.currentProgress,
      category: "Current",
    });

    // Add target line (100% at the end of performance cycle)
    data.push({
      Date: moment(perfCycleState?.startingOn).format("DD.MM.YYYY"),
      scales: 0,
      category: "Target",
    });

    data.push({
      Date: moment(perfCycleState?.endingOn).format("DD.MM.YYYY"),
      scales: 100,
      category: "Target",
    });

    return data;
  }

  function getCurrentDate() {
    let output = moment();

    if (moment() < moment(perfCycleState?.startingOn)) {
      output = moment(perfCycleState?.startingOn);
    } else if (moment() > moment(perfCycleState?.endingOn)) {
      output = moment(perfCycleState?.endingOn);
    } else {
      output = moment();
    }

    return output;
  }

  const config = {
    data: generateGraphData(),
    height: 150,
    padding: "auto",
    xField: "Date",
    yField: "scales",
    seriesField: "category",
    xAxis: {
      tickCount: 5,
    },
    yAxis: {
      maxLimit: 100,
      label: {
        formatter: (v) => `${v}%`,
      },
    },
    color: ["#1890ff", "#ff4d4f"], // Blue for Current, Red for Target
    lineStyle: ({ category }) => {
      if (category === "Target") {
        return {
          lineDash: [4, 4], // Dashed line for target
          lineWidth: 2,
        };
      }
      return {
        lineWidth: 2,
      };
    },
    point: {
      size: 4,
      shape: ({ category }) => {
        return category === "Current" ? "circle" : "square";
      },
    },
    legend: {
      position: "top-right",
    },
    tooltip: {
      formatter: (datum) => {
        return {
          name: datum.category,
          value: `${datum.scales}%`,
        };
      },
    },
    meta: {
      scales: {
        min: 0,
        max: 100,
      },
    },
  };

  return <Line loading={!canStart} {...config} />;
};

export default TopPlanProgressGraph;
